module.exports = __webpack_public_path__ + "static/media/newChat.b6b13aa4.png";